export default function all_news() {
  return [
    {
      img: 'https://placehold.co/400x400',
      title: 'Nieuwsartikel 1',
      teaser: 'Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet',
      body: "Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet<br />Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet<br /><br />Lorem ipsum dolor sit amet Lorem ipsum dolor sit ametLorem ipsum dolor sit amet Lorem ipsum dolor sit ametLorem ipsum dolor sit amet Lorem ipsum dolor sit amet",
      date: "20/05/2026 11:33",
      author: 'Admin'
    }
  ]
}